module.exports = __webpack_public_path__ + "img/phone-recharge_explain.7ad9e1d1.png";